import { useContext, useEffect, useRef, useState } from "react";
import CustomerSocketContext from "./context";
import { CustomerStateDataType } from "./types";
import CustomerSocket, { InitiateRideParamsType } from "./socket";
import { SocketStateType } from "../base";
import { ETAType, LocationObjectType } from "../base/types";

export const useCustomerSocket = () => useContext(CustomerSocketContext);

export type CustomerSocketStateSelectorType = (state: SocketStateType<CustomerStateDataType>) => any;

const defaultSelector = (state: SocketStateType<CustomerStateDataType>) => state;
const nullFunc = () => {};

export const useCustomerSocketState = (selector: CustomerSocketStateSelectorType = defaultSelector) => {
  const customerSocket = useCustomerSocket() as CustomerSocket;
  const [state, setState] = useState(selector(customerSocket.state));
  useEffect(() => {
    if (customerSocket) {
      return customerSocket.subscribe((nextState, socket) => {
        if (socket === customerSocket) {
          setState(selector(nextState));
        }
      })
    }
    return nullFunc;
  }, [selector, customerSocket]);
  return state;
}

export type CustomerSocketActionsType = {
  sendLocation: (location: LocationObjectType) => void,
  initiateRide: (initiateRideParams: InitiateRideParamsType) => void,
  cancelRide: (eta?: ETAType) => void
}

export const useCustomerSocketActions = () => {
  const customerSocket = useCustomerSocket() as CustomerSocket;
  const prevSocket = useRef<CustomerSocket | null>(null);
  const prevActions = useRef<CustomerSocketActionsType | {}>({});
  if (customerSocket !== prevSocket.current) {
    // @ts-ignore
    prevActions.current.sendLocation = customerSocket.sendLocation;
    // @ts-ignore
    prevActions.current.initiateRide = customerSocket.initiateRide;
    // @ts-ignore
    prevActions.current.cancelRide = customerSocket.cancelRide;
    // @ts-ignore
    prevSocket.current = customerSocket;
  }
  return prevActions.current as CustomerSocketActionsType;
};
